import { DataV2API } from "../Endpoints";

class Data {
    getStorageLocations() {
        return DataV2API.get("/storagelocations");
    }

    getManufacturer() {
        return DataV2API.get("/manufacturers");
    }

    getAvailable() {
        // TODO
        return DataV2API.get("/data/available");
    }

    getMarketData({ year, month, pharmacy }) {
        return DataV2API.get("/data/" + pharmacy.id + "/" + year + "/" + month);
    }

    getMarketDataConsolidate({ year, month, pharmacyGroup }) {
        return DataV2API.get("/consolidate/" + pharmacyGroup.id + "/" + year + "/" + month);
    }
}

export default new Data();
